import React from "react";
import { UIFlightData } from "@flights/types";
import useUpgradeFareInfoController from "./useUpgradeFareInfo.controller";
import { Text } from "@bookingcom/bui-react";

const useUpgradeFareInfoMobile = (flight: UIFlightData) => {
  const { header, subheader, fareInfoContent } = useUpgradeFareInfoController(flight);

  if (!fareInfoContent) return undefined;

  return {
    header,
    subheader,
    content: (
      <div>
        <Text variant="body_2">{fareInfoContent.content}</Text>
        <Text variant="body_2">{fareInfoContent.price}</Text>
        <Text variant="body_2">{fareInfoContent.supportText}</Text>
      </div>
    )
  };
};

export default useUpgradeFareInfoMobile;
